// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { RelatedType } from '../../../../services';
import { AbstractAdapter, getIdentifierConstraint, getRelatedTypeConstraint } from '../../../_abstract/adapter';
import { ModuleDriver } from '../../../_contracts';
import { getModuleBase } from '../../../_helpers/adapter';
import { EmbedVersion } from '../../Embed.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class EmbedYouTubeAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `EmbedModule` to the `EmbedYouTubeToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        this.validate(content, {
            description: {
                type: 'string'
            },
            videoId: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof content.thumbnail !== 'undefined') {
            this.validate(content.thumbnail, {
                type: getRelatedTypeConstraint(RelatedType.File),
                value: getIdentifierConstraint()
            });
        }
        const { description, thumbnail, videoId } = content;
        let meta = {};
        let raw = `#YT[ videoId: ${videoId} ]`;
        if (typeof description === 'string') {
            meta = { ...meta, description };
            raw = raw.substring(0, raw.length - 1) + `| description: ${description} ]`;
        }
        if (typeof thumbnail !== 'undefined' && typeof thumbnail.value === 'number') {
            const thumbnailId = thumbnail.value;
            if (typeof thumbnailId === 'number') {
                meta = { ...meta, thumbnailId };
                raw = raw.substring(0, raw.length - 1) + `| thumbnailId: ${thumbnailId} ]`;
            }
        }
        const token = {
            content: videoId,
            raw,
            type: TokenType.EmbedYouTube
        };
        if (Object.keys(meta).length > 0) {
            token.meta = meta;
        }
        return token;
    }
    /**
     * Adapts (translates/maps) the passed-in `EmbedYouTubeToken` to the `EmbedModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof token.meta !== 'undefined') {
            this.validate(token.meta, {
                description: {
                    type: 'string'
                },
                thumbnailId: {
                    type: 'number'
                }
            });
        }
        const { content: videoId, meta } = token;
        const object = {
            ...getModuleBase(),
            content: { videoId },
            driver: ModuleDriver.Embed,
            version: EmbedVersion.YouTube
        };
        if (typeof meta !== 'undefined') {
            const { description, thumbnailId } = meta;
            if (typeof description === 'string') {
                object.content.description = description;
            }
            if (typeof thumbnailId === 'number') {
                object.content.thumbnail = {
                    type: RelatedType.File,
                    value: thumbnailId
                };
            }
        }
        object.content.type = EmbedVersion.YouTube;
        return object;
    }
}
